import { MARQUEE } from "@/data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-display text-5xl md:text-7xl font-black uppercase tracking-tight px-8 text-transparent [-webkit-text-stroke:1px_rgba(226,232,240,0.55)] hover:text-white transition-colors">
          {w}
        </span>
        <svg width="28" height="28" viewBox="0 0 24 24" className="text-[var(--blue)] shrink-0" aria-hidden>
          <path fill="currentColor" d="M12 2l1.6 3 3.3-.9.3 3.4 3.2 1.2-1.6 3 1.6 3-3.2 1.2-.3 3.4-3.3-.9L12 22l-1.6-3-3.3.9-.3-3.4-3.2-1.2 1.6-3-1.6-3 3.2-1.2.3-3.4 3.3.9z" />
          <circle cx="12" cy="12" r="3.5" fill="#070D1F" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee-section" aria-label="Áreas de atuação" className="relative border-y border-white/10 bg-[var(--navy)] py-8 overflow-hidden">
    <div className="flex w-max marquee-track">
      <Row />
      <Row />
    </div>
  </section>
);
